var _ellipse, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 8,
    rx: 7.5,
    ry: 8,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.27239 13.1C5.95239 13.1 5.70239 13.01 5.52239 12.83C5.34239 12.65 5.25239 12.4 5.25239 12.08C5.25239 11.96 5.26239 11.815 5.28239 11.645C5.30239 11.475 5.32739 11.3 5.35739 11.12C5.38739 10.93 5.41739 10.755 5.44739 10.595C5.48739 10.425 5.51739 10.28 5.53739 10.16L6.55739 5.14999L8.26739 4.96999L7.00739 11.24C6.99739 11.32 6.98239 11.425 6.96239 11.555C6.94239 11.675 6.93239 11.78 6.93239 11.87C6.93239 12.02 6.96739 12.14 7.03739 12.23C7.11739 12.32 7.23239 12.37 7.38239 12.38C7.32239 12.63 7.18239 12.81 6.96239 12.92C6.75239 13.04 6.52239 13.1 6.27239 13.1ZM7.78739 3.82999C7.46739 3.82999 7.20239 3.75499 6.99239 3.60499C6.78239 3.44499 6.67739 3.20999 6.67739 2.89999C6.67739 2.56999 6.78739 2.32999 7.00739 2.17999C7.22739 2.01999 7.49739 1.93999 7.81739 1.93999C8.13739 1.93999 8.40239 2.01999 8.61239 2.17999C8.82239 2.32999 8.92739 2.55999 8.92739 2.86999C8.92739 3.19999 8.81739 3.44499 8.59739 3.60499C8.37739 3.75499 8.10739 3.82999 7.78739 3.82999Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alertIcon.eb34eb05d178d7c9971b51ad49e19449.svg";
export { ForwardRef as ReactComponent };